// Make localized variable available globally
if (typeof localized !== 'undefined') {
  window.localized = localized;
}

import { createApp } from 'vue';
import App from '@components/App.vue';
import AdminApp from '@components/AdminApp.vue';
import router from './setup/router';
import store from '@utilities/store/store.js';
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import 'primeicons/primeicons.css'
import './index.css';

// Import all PrimeVue components
import ConfirmDialog from 'primevue/confirmdialog';
import ToggleButton from 'primevue/togglebutton';
import ColumnGroup from 'primevue/columngroup';
import ScrollPanel from 'primevue/scrollpanel';
import InputNumber from 'primevue/inputnumber';
import MultiSelect from 'primevue/multiselect';
import DatePicker from 'primevue/datepicker';
import DataTable from 'primevue/datatable';
import InputText from 'primevue/inputtext';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import TextArea from 'primevue/textarea';
import Fieldset from 'primevue/fieldset';
import Checkbox from 'primevue/checkbox';
import Divider from 'primevue/divider';
import Toolbar from 'primevue/toolbar';
import TabList from 'primevue/tablist';
import Button from 'primevue/button';
import Column from 'primevue/column';
import Dialog from 'primevue/dialog';
import Select from 'primevue/select';
import Toast from 'primevue/toast';
import Panel from 'primevue/panel';
import Card from 'primevue/card';
import Tabs from 'primevue/tabs';
import Row from 'primevue/row';
import Tag from 'primevue/tag';
import Tab from 'primevue/tab';

import smogBuddyTheme from './setup/theme';

const primeVueConfig = {
    theme: {
        preset: smogBuddyTheme,
        options: {
            prefix: 'prime',
            darkModeSelector: false
        },
    },
};

// Main App
const app = createApp(App);
app.use(router);
app.use(store);
app.use(PrimeVue, primeVueConfig);
app.use(ConfirmationService);
app.use(ToastService);

// Register PrimeVue components
const components = [
    ['ConfirmDialog', ConfirmDialog],
    ['ToggleButton', ToggleButton],
    ['ColumnGroup', ColumnGroup],
    ['ScrollPanel', ScrollPanel],
    ['InputNumber', InputNumber],
    ['MultiSelect', MultiSelect],
    ['FancyTextArea', TextArea],
    ['DatePicker', DatePicker],
    ['DataTable', DataTable],
    ['InputText', InputText],
    ['TabPanels', TabPanels],
    ['TabPanel', TabPanel],
    ['Fieldset', Fieldset],
    ['Checkbox', Checkbox],
    ['TabList', TabList],
    ['Toolbar', Toolbar],
    ['Divider', Divider],
    ['Column', Column],
    ['Button', Button],
    ['Select', Select],
    ['Dialog', Dialog],
    ['Panel', Panel],
    ['Toast', Toast],
    ['Card', Card],
    ['Tabs', Tabs],
    ['Row', Row],
    ['Tag', Tag],
    ['Tab', Tab]
];

components.forEach(([name, component]) => {
    app.component(name, component);
});

app.mount('#smog-buddy');

// Admin App
const adminApp = createApp(AdminApp);
adminApp.use(router);
adminApp.use(store);
adminApp.use(PrimeVue, primeVueConfig);
adminApp.use(ConfirmationService);
adminApp.use(ToastService);

components.forEach(([name, component]) => {
    adminApp.component(name, component);
});

adminApp.mount('#smog-buddy-admin');
